import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock, AlertCircle, TrendingDown } from 'lucide-react';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    // Set countdown to 24 hours from now
    const endTime = new Date().getTime() + 24 * 60 * 60 * 1000;
    const updateCountdown = () => {
      const now = new Date().getTime();
      const distance = endTime - now;
      if (distance < 0) {
        setTimeLeft({
          hours: 0,
          minutes: 0,
          seconds: 0
        });
        return;
      }
      const hours = Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
      const minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
      const seconds = Math.floor(distance % (1000 * 60) / 1000);
      setTimeLeft({
        hours,
        minutes,
        seconds
      });
    };
    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, []);
  const scrollToPurchase = () => {
    const element = document.getElementById('purchase-section');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <motion.div initial={{
    y: -100,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} transition={{
    type: 'spring',
    stiffness: 100,
    damping: 15,
    delay: 0.5
  }} className="sticky top-0 z-50 bg-gradient-to-r from-[#7C2D2D] via-[#8B4513] to-[#7C2D2D] text-[#F4E8D8] shadow-lg border-b-4 border-[#2D241E]" data-id="element-32">
      <div className="max-w-7xl mx-auto px-4 py-3" data-id="element-33">
        <div className="flex flex-col md:flex-row items-center justify-between gap-3" data-id="element-34">
          {/* Scarcity Message */}
          <div className="flex items-center gap-2 text-sm md:text-base font-sans" data-id="element-35">
            <AlertCircle className="w-5 h-5 flex-shrink-0 animate-pulse" data-id="element-36" />
            <span className="font-bold" data-id="element-37">OFERTA LIMITADA:</span>
            <span className="hidden sm:inline" data-id="element-38">
              Solo quedan 12 cupos disponibles al precio promocional
            </span>
            <span className="sm:hidden" data-id="element-39">12 cupos restantes</span>
          </div>

          {/* Countdown Timer */}
          <div className="flex items-center gap-3" data-id="element-40">
            <div className="flex items-center gap-2" data-id="element-41">
              <Clock className="w-5 h-5 flex-shrink-0" data-id="element-42" />
              <span className="text-sm font-medium hidden md:inline" data-id="element-43">
                Termina en:
              </span>
            </div>

            <div className="flex items-center gap-2 bg-[#2D241E] px-4 py-2 rounded-sm border-2 border-[#F4E8D8]/30 shadow-inner" data-id="element-44">
              <div className="flex flex-col items-center" data-id="element-45">
                <span className="font-serif font-bold text-2xl leading-none tabular-nums" data-id="element-46">
                  {String(timeLeft.hours).padStart(2, '0')}
                </span>
                <span className="text-[10px] uppercase tracking-wider opacity-80" data-id="element-47">
                  hrs
                </span>
              </div>
              <span className="font-bold text-xl opacity-60" data-id="element-48">:</span>
              <div className="flex flex-col items-center" data-id="element-49">
                <span className="font-serif font-bold text-2xl leading-none tabular-nums" data-id="element-50">
                  {String(timeLeft.minutes).padStart(2, '0')}
                </span>
                <span className="text-[10px] uppercase tracking-wider opacity-80" data-id="element-51">
                  min
                </span>
              </div>
              <span className="font-bold text-xl opacity-60" data-id="element-52">:</span>
              <div className="flex flex-col items-center" data-id="element-53">
                <span className="font-serif font-bold text-2xl leading-none tabular-nums" data-id="element-54">
                  {String(timeLeft.seconds).padStart(2, '0')}
                </span>
                <span className="text-[10px] uppercase tracking-wider opacity-80" data-id="element-55">
                  seg
                </span>
              </div>
            </div>

            {/* CTA Button */}
            <button onClick={scrollToPurchase} className="hidden lg:flex items-center gap-2 bg-[#F4E8D8] text-[#7C2D2D] px-4 py-2 rounded-sm font-serif font-bold text-sm hover:bg-[#FFF8E7] transition-colors border border-[#8B4513] shadow-md" data-id="element-56">
              <TrendingDown className="w-4 h-4" data-id="element-57" />
              <span data-id="element-58">APROVECHAR OFERTA</span>
            </button>
          </div>
        </div>

        {/* Mobile CTA */}
        <div className="lg:hidden mt-2" data-id="element-59">
          <button onClick={scrollToPurchase} className="w-full flex items-center justify-center gap-2 bg-[#F4E8D8] text-[#7C2D2D] px-4 py-2 rounded-sm font-serif font-bold text-sm hover:bg-[#FFF8E7] transition-colors border border-[#8B4513] shadow-md" data-id="element-60">
            <TrendingDown className="w-4 h-4" data-id="element-61" />
            <span data-id="element-62">APROVECHAR OFERTA AHORA</span>
          </button>
        </div>
      </div>
    </motion.div>;
}